<template>
    <div>
        <div class="app-title">
            <em-view-title key="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <app-content>
            <drawer-handler is-left to-invisible class="col-3" @toggle="chart.resize()">
                <em-filter-tree filterEnable ref="emTree"
                                :entity="modelName"
                                filterState="levelTreeFilter"
                                loadState="levelTreeNodes"
                                check-enable
                                enable-switch-check-related>
                </em-filter-tree>
            </drawer-handler>
            <div class="d-flex flex-column col">
                <div class="card d-flex flex-row align-items-center mb-1 p-1">
                    <b-form-datepicker class="w-200px" v-model="fromDate"></b-form-datepicker>
                    <i class="el-icon-minus"></i>
                    <b-form-datepicker class="w-200px" v-model="toDate"></b-form-datepicker>
                    <b-form-select v-if="dateMode" class="ml-1 w-200px" v-model="dateSplitType"
                                   :options="dateSplitTypeOptions"></b-form-select>
                    <b-form-input class="ml-1 w-200px" readonly v-model="projectCode"
                                  placeholder="选择项目"
                                  @click="$refs.projectEntitySelector.showModal()"></b-form-input>
                    <AvatarButton :icon="dateMode ? 'el-icon-open' : 'el-icon-turn-off'"
                                  class="ml-1"
                                  @btnClick="dateMode = !dateMode" title="显示模式"></AvatarButton>
                    <AvatarButton icon="el-icon-search"
                                  class="ml-1"
                                  :loading="loading"
                                  @btnClick="getRemoteData"
                                  title="查询结果"></AvatarButton>
                    <AvatarButton icon="el-icon-download"
                                  class="ml-1"
                                  @btnClick="$refs.exportChart.showModal()"
                                  title="导出"></AvatarButton>
                </div>
                <div class="card col" id="charContainer">
                    <div id="schedule_over_view_chart" class="h-100 w-100"></div>
                </div>
            </div>
        </app-content>

        <em-modal-normal-input-entity-selector ref="projectEntitySelector"
                                               entity="sithMesPrdProjectInfo"
                                               @entityModalSelectSelected="handleProjectSelect">
        </em-modal-normal-input-entity-selector>

        <ReBModal header="导出报表" ref="exportChart">
            <b-list-group>
                <b-list-group-item v-for="(item,index) of exportList"
                                   :key="index" button
                                   @click="exportPlanChart(item)">
                    {{ item.name }}
                </b-list-group-item>
            </b-list-group>
        </ReBModal>
    </div>
</template>

<script>
import AppContent from "@/components/echarts-part/stuff/AppContent";
import EmCommonApi from "@/mixin/em/common/api";
import emCommonListMixin from "@/mixin/em/common/list";
import * as echarts from "echarts";
import EmFilterTree from "@/components/em/EmFilterTree";
import DrawerHandler from "@/components/echarts-part/CalendarShift/cells/stuffs/DrawerHandler";
import emLevelTreeListMixin from "@/mixin/em/levelTree/list";
import AvatarButton from "@/components/echarts-part/CalendarShift/cells/stuffs/AvatarButton";
import moment from "moment";
import EmModalNormalInputEntitySelector from "@/components/em/EmModal/NormalInputEntitySelector";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";

export default {
    name: "ScheduleOverView",
    components: {ReBModal, EmModalNormalInputEntitySelector, AvatarButton, DrawerHandler, AppContent, EmFilterTree},
    mixins: [EmCommonApi, emCommonListMixin, emLevelTreeListMixin],
    computed: {
        modelName() {
            return 'sithMesMstLocation';
        }
    },
    data() {
        return {
            chart: null,
            chartData: [],
            selectedId: [],
            fromDate: new Date(),
            toDate: '',
            loading: false,
            dateMode: true,
            dateSplitType: 'day',
            dateSplitTypeOptions: [
                {value: 'day', text: '每天'},
                {value: 'week', text: '每周'},
                {value: 'month', text: '每月'},
                {value: 'quarter', text: '每季度'},
                {value: 'year', text: '每年'},
            ],
            projectCode: null,
            exportList: [
                {url: "/export?needFilter=true", name: '项目负荷统计报表'},
                {url: "/export?needFilter=false", name: '项目负荷统计报表(新)'},
                {url: "/capacity?isStandard=true", name: '标准能力'},
                {url: "/capacity?isStandard=false", name: '最大加班能力'},
            ]
        }
    },
    watch: {
        dateMode() {
            this.loadChart();
        }
    },
    mounted() {
        this.$_emLevelTreeListMixin_retrieveLevelTreeNodes();
        this.chart = echarts.init(document.getElementById('schedule_over_view_chart'));
        this.loadChart();
    },
    methods: {
        getRemoteData() {
            let checkedNodes = this.$refs.emTree.getCheckedNodes();
            let tempList = []
            for (let item of checkedNodes) {
                tempList.push(item.id);
            }
            if (tempList.length === 0) {
                this.$message.warning("没有选择任何有效位置");
                return;
            }
            if (this.toDate === '' || this.toDate === undefined) {
                this.$message.warning("请选择结束日期");
                return;
            }
            let startDate = moment(this.fromDate).format(this.$t("em.datetime.format.viewMode"));
            let endDate =  moment(this.toDate).format(this.$t("em.datetime.format.viewMode"));
            if (endDate < startDate) {
                this.$message.warning("开始时间不能大于结束时间");
                return;
            }
            this.loading = true;
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_SITHMES_PRD_URL + '/sithMesPrdPpOperation/plan/chart/' + (this.dateMode ? 'date' : 'location'),
                data: {
                    fromDate: startDate,
                    toDate: endDate,
                    targetIds: tempList,
                    dateSplitType: this.dateSplitType,
                    code: this.projectCode
                }
            }).then(response => {
                console.log(response);
                let temp = response.data.itemList;
                let tempList = [];
                for (let item of temp) {
                    tempList.push([item.name,
                        this.fixedNumber(item.capacityStandard),
                        this.fixedNumber(item.capacityOverload),
                        this.fixedNumber(item.content1SI),
                        this.fixedNumber(item.contentC),
                        this.fixedNumber(item.contentS),
                        this.fixedNumber(item.contentOthers),
                        this.fixedNumber(item.contentFS),
                        this.fixedNumber(item.contentFC),
                        this.fixedNumber(item.contentFA)]);
                }
                this.chartData = tempList;
                this.loadChart();
            }).finally(() => this.loading = false);
        },
        fixedNumber(num) {
            return num !== undefined ? Number.parseFloat(num.toFixed(2)) : 0;
        },
        handleProjectSelect(entity) {
            this.projectCode = entity == null ? null : entity.projectCode;
        },
        loadChart() {
            let chart = this.chart
            let option = {
                color: ['#5a6fc0', '#9eca7f', '#f2ca6b', '#de6e6a', '#85bedb', '#59a076', '#ec8a5d', '#9263af', '#dc82c8', '#5a6fc0', '#dfe2e6'],
                title: {
                    text: this.dateMode ? '日期模式' : '工位模式',
                },
                grid: {
                    right: '5%'
                },
                toolbox: {
                    show: false
                },
                tooltip: {
                    trigger: 'axis',
                    confine: true,
                    axisPointer: {
                        type: 'shadow'
                    },
                    order: 'seriesDesc'
                },
                dataset: {
                    source: this.chartData
                },
                xAxis: [{
                    type: 'category'
                }],
                yAxis: [{
                    type: 'value'
                }],
                dataZoom: [
                    {
                        type: 'slider',
                        xAxisIndex: 0,
                        start: 0,
                        endValue: 20,
                        minValueSpan: 4
                    }, {
                        type: 'inside',
                        xAxisIndex: 0,
                        start: 0,
                        endValue: 20,
                        minValueSpan: 4
                    }
                ],
                series: [
                    {
                        name: '标准能力',
                        type: 'line',
                        z: 4
                    },
                    {
                        name: '最大加班能力',
                        type: 'line',
                        areaStyle: {},
                        z: 3
                    },
                    {
                        name: '服务类订单',
                        type: 'bar',
                        stack: 'content',
                        z: 3
                    },
                    {
                        name: 'C类订单',
                        type: 'bar',
                        stack: 'content',
                        z: 3
                    },
                    {
                        name: 'S类订单',
                        type: 'bar',
                        stack: 'content',
                        z: 3
                    },
                    {
                        name: 'NCR/自制件/本地化',
                        type: 'bar',
                        stack: 'content',
                        z: 3
                    },
                    {
                        name: '预计S订单',
                        type: 'bar',
                        stack: 'content',
                        z: 3
                    },
                    {
                        name: '预计C类订单',
                        type: 'bar',
                        stack: 'content',
                        z: 3
                    },
                    {
                        name: '预计服务类订单',
                        type: 'bar',
                        stack: 'content',
                        z: 3
                    }
                ]
            }
            chart.setOption(option)
            window.onresize = function () {
                chart.resize()
            }
            chart.resize();
        },
        exportPlanChart(row) {
            this.$store.dispatch("api/post", {
                url: process.env.VUE_APP_REPORT_API_URL + "report-service/mmf/report/dispatcher/asynchronous",
                data: {
                    requestUrl: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdPpOperation/plan/chart" + row.url,
                    requestParam: {},
                    reportName: row.name
                }
            }, {
                root: true
            }).then(() => this.$message.success("操作成功"));
        }
    }
}
</script>

<style scoped>
.w-200px {
    width: 200px;
}
</style>